// Configuracion de la URL base de la API
//
// Prioridad de resolucion:
// 1. Variable de entorno REACT_APP_API_URL (build-time, viene de .env.production)
// 2. localhost -> http://localhost:8080 (desarrollo)
// 3. Cualquier otro hostname -> string vacio = mismo origen (Nginx proxea /api/ al backend)

const ENV_API_URL = process.env.REACT_APP_API_URL;

const getApiBaseUrl = () => {
    // 1. Si hay env var definida, ganadora absoluta
    if (ENV_API_URL && ENV_API_URL.trim() !== '') {
        console.log('📡 API Base URL desde REACT_APP_API_URL:', ENV_API_URL);
        return ENV_API_URL.replace(/\/+$/, ''); // sin trailing slash
    }

    const hostname = window.location.hostname;

    // 2. Desarrollo local
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        console.log('🔧 Entorno detectado: DESARROLLO (localhost)');
        return 'http://localhost:8080';
    }

    // 3. Produccion: mismo origen, Nginx proxea /api/
    console.log('🚀 Entorno detectado: PRODUCCION (' + hostname + ') - usando mismo origen');
    return ''; // string vacio = los requests salen al mismo origen
};

export const API_BASE_URL = getApiBaseUrl();

console.log('🌐 Accediendo desde:', window.location.href);
console.log('📡 API Base URL configurada:', API_BASE_URL || '(mismo origen)');

// Helper para construir URLs completas
export const getApiUrl = (endpoint) => {
    const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${API_BASE_URL}${normalizedEndpoint}`;
};

export default {
    BASE_URL: API_BASE_URL,
    getUrl: getApiUrl
};
